export default "__VITE_ASSET___ewJD0zO9$SsiDvawfmAUw__ 200w, __VITE_ASSET__hO4dd8ILk$iZF7aFIOUkdg__ 500w, __VITE_ASSET__rN_1li4k2aIbHGs0zKW8QQ__ 1000w";